import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const FailureOverlayWrapper = withConfig(theme => styled('div', { label: 'FailureOverlayWrapper' })`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${theme.star.idMission.bgColorTertiary};
    z-index: ${theme.star.zIndexIdMission.idMission};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 24px;
`);

export const FailureOverlayLogo = styled('div', { label: 'FailureOverlayLogo' })`
    width: 200px;
    display: flex;
    justify-content: center;
    margin-bottom: 32px;

    svg {
        width: 100%;
        height: 100%;
    }
`;

export const FailureOverlayIcon = styled('div', { label: 'FailureOverlayIcon' })`
    width: 64px;
    height: 64px;
    margin-bottom: 12px;

    svg {
        width: 100%;
        height: 100%;
    }
`;

export const FailureOverlayText = styled('div', { label: 'FailureOverlayText' })`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    text-align: center;
`;

export const FailureOverlayParagraph = withConfig(theme => styled('div', { label: 'FailureOverlayParagraph' })`
    width: 316px;
    margin: 0;
    font-size: ${theme.star.fontSize.regular};
    font-weight: ${theme.star.fontWeight.medium};
    color: ${theme.star.idMission.bgColorSecondary};
`);

export const FailureOverlayContactLink = withConfig(theme => styled('a', { label: 'FailureOverlayContactLink' })`
    color: ${theme.star.signUp.txtColorTertiary};
    text-decoration: none;
    font-weight: ${theme.star.fontWeight.bold};
    transition: opacity 0.2s ease;
    &:hover {
        opacity: 0.7;
    }
`);

export const FailureOverlayButtonWrapper = styled('div', { label: 'FailureOverlayButtonWrapper' })`
    width: 240px;
    margin-top: 60px;

    button {
        width: 100%;
    }
`;
